import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) return navigate("/login");
      try {
        const { data } = await apiClient.post("/auth/session", { session_id: sessionId });
        localStorage.removeItem("pousse_token");
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);

        // Pending onboarding: the user filled the questionnaire before signing in with Google.
        const pending = localStorage.getItem("pousse_pending_onboarding");
        const draftRaw = localStorage.getItem("pousse_questionnaire");
        if (pending && draftRaw) {
          localStorage.removeItem("pousse_pending_onboarding");
          try {
            const f = (JSON.parse(draftRaw)?.f) || {};
            const payload = {
              ...f, type: "initial",
              height_cm: parseFloat(f.height_cm), weight_kg: parseFloat(f.weight_kg),
              target_weight_kg: f.target_weight_kg ? parseFloat(f.target_weight_kg) : null,
            };
            const { data: q } = await apiClient.post("/questionnaire", payload);
            localStorage.removeItem("pousse_questionnaire");
            if (q.health_flag && q.health_flag !== "clear") {
              return navigate("/programme", { replace: true });
            }
            await apiClient.post("/programs/generate").catch(() => {});
          } catch (e) { /* fall through to app */ }
          return navigate("/programme", { replace: true });
        }
        navigate("/app", { replace: true });
      } catch (e) {
        navigate("/login");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0F0D]">
      <div className="flex flex-col items-center gap-4" data-testid="auth-callback-loading">
        <div className="h-10 w-10 rounded-full border-2 border-lime-400 border-t-transparent animate-spin" />
        <p className="text-lime-200 text-sm">Connexion en cours…</p>
      </div>
    </div>
  );
}
